<template>
   <div>
      
      <ddoAlert :errors="level.errors"/> 

      <v-card-actions>
         <div class="flex-grow-1"></div>
         <v-btn v-if="level.dialogValues.form_close"  small rounded class="warning" @click="close_window">{{ $t('buttons.close') }}</v-btn>
         <v-btn v-if="level.dialogValues.form_create" small rounded :disabled="level.dialogValues.disable_create" class="primary" @click="confirm_create_row(row)">{{ $t('buttons.create') }}</v-btn>
         <v-btn v-if="level.dialogValues.form_update" small rounded :disabled="level.dialogValues.disable_update" class="primary" @click="confirm_update_row(row)">{{ $t('buttons.update') }}</v-btn>
         <v-btn v-if="level.dialogValues.form_delete" small rounded :disabled="level.dialogValues.disable_delete" class="error"   @click="confirm_delete_row(row)">{{ $t('buttons.delete') }}</v-btn>
      </v-card-actions>

      <v-dialog name="EditWarning" v-model="subdialogShow" data-app="true" persistent max-width="600">
         <v-card>
            <v-card-title>
               <span class="headline">Confirmation</span>
            </v-card-title>
            <v-card-text>
               <slot name="content">
                  <p>Default Confirm Text</p>
               </slot>
            </v-card-text>
            <v-card-actions>
               <div class="flex-grow-1"></div>
               <v-btn small class="warning" rounded @click="cancel_confirmation(row)">{{ $t('buttons.cancel') }}</v-btn>
               <v-btn small class="primary" rounded v-if="level.dialogValues.form_create||level.dialogValues.form_update" @click="accept_confirmation(row)">{{ $t('buttons.confirm') }}</v-btn>
               <v-btn small class="error"   rounded v-if="level.dialogValues.form_delete" @click="accept_confirmation(row)">{{ $t('buttons.confirm') }}</v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>
   </div>
</template>

<script>
import CardUpdatableFooter from '@/components/partials/CardUpdatableFooter.vue';

export default {
   name: 'CardUpdatableFooterConfirm',
   mixins: [CardUpdatableFooter],

   data: function () {
      return {
         subdialogShow: false,
         originalMethod: null,
      }
   },

   methods: {

      check_if_confirm_is_skipped(method,row) {
         var check = true;
         if ( this.level.callbacks.check_skip_confirm ) {
            check = this.level.callbacks.check_skip_confirm(method,row);
            console.log('check_if_confirm_is_skipped, method='+method+', callback returns '+check);
         }
        return check;
      },

      async confirm_create_row(row) {
         console.log('confirm_create_row, row='+JSON.stringify(row));
         this.originalMethod = 'create';
         if ( this.check_if_confirm_is_skipped(this.originalMethod,row) ) {
            await this.accept_confirmation(row);
         } else {
            this.subdialogShow = true;
         }
      },

      async confirm_update_row(row) {
         console.log('confirm_update_row');
         this.originalMethod = 'update';
         if ( this.check_if_confirm_is_skipped(this.originalMethod,row) ) {
            await this.accept_confirmation(row);
         } else {
            this.subdialogShow = true;
         }
      },

     async confirm_delete_row(row) {
         this.originalMethod = 'delete';
         this.check_if_confirm_is_skipped(this.originalMethod,row);
         console.log('confirm_delete_row, row='+JSON.stringify(row));
         this.subdialogShow = true;
      },

      async cancel_confirmation(row) {
         this.subdialogShow = false;
      },

      async accept_confirmation(row) {
         console.log('accept_confirmation');
         this.subdialogShow = false;
         switch(this.originalMethod) {
            case 'create' :
               console.log('accept_confirmation, before create_row, row='+JSON.stringify(row));
               await this.create_row(row);
               break
            case 'update' :
               console.log('accept_confirmation, before update_row, row='+JSON.stringify(row));
               await this.update_row(row);
               break
            case 'delete' :
               console.log('accept_confirmation, before delete_row, row='+JSON.stringify(row));
               await this.delete_row(row);
               break
         }
      },

   },
  
}
</script>